import * as React from "react";
import { CartItem, Price, Spectacle } from "../types";
import AcceptRegulations from "./AcceptRegulations";

interface Props {
  spectacle: Spectacle;
  cart: CartItem[];
  changePrice: (SeatId: number) => (e: any) => void;
  areaPrices: { [key: string]: Price[] };
  cartItemInfo: string;
  unselectSeat: any;
}

const daysWeek = [
  "Niedziela",
  "Poniedziałek",
  "Wtorek",
  "Środa",
  "Czwartek",
  "Piątek",
  "Sobota",
];

const months = [
  "Styczeń",
  "Luty",
  "Marzec",
  "Kwiecień",
  "Maj",
  "Czerwiec",
  "Lipiec",
  "Sierpień",
  "Wrzesień",
  "Październik",
  "Listopad",
  "Grudzień",
];

const CartSummary: React.FC<Props> = ({
  cart,
  changePrice,
  areaPrices,
  spectacle,
  cartItemInfo,
  unselectSeat,
}) => {
  const date = new Date(spectacle.Date);

  const formattedDate = new Date(date).toLocaleDateString("pl-PL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const formattedHour = new Date(date).toLocaleTimeString("pl-PL");

  return (
    <div className="ui cart-box summarize">
      <p className="time day">
        <b>
          {formattedDate}
        </b>
      </p>
      <p className="h6 time hour">{formattedHour}</p>
      <h5 className="play-name">{spectacle.DisplayName}</h5>
      <br />
      <p>
        <b>Wybrano {cart.length} miejsca:</b>
      </p>

      <div className="form ticket-selection">
        {cart.map((cartItem: CartItem, index) => {
          return (
            <div className="form-group row justify-content-center ticket" key={index}>
              <label className="col-lg-12 col-12">
                <span className={cartItemInfo}>
                  <span>{cartItem.Sector}</span>
                  <span>Rząd: {cartItem.Row}</span>
                  <span>Miejsce: {cartItem.Number}</span>
                </span>
              </label>
              <div className="col-lg-10 col-9 select-wrap">
                <select
                  className="form-control"
                  onChange={changePrice(cartItem.SeatId)}
                  value={cartItem.PriceId}
                >
                  {areaPrices[cartItem.PriceAreaId].map((price: any, second_index) => {
                    return (
                      <option value={price.PriceId} key={second_index}>
                        Bilet {price.Name}: {price.Value} zł
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="col-lg-2 col text-right">
                <button className="btn btn-outline-dark" value={cartItem.SeatId} onClick={unselectSeat(cartItem.SeatId)}>
                  <span className="icon-trash-2 solo"></span>
                </button>
              </div>

              <div className="col-lg-12">
                <hr />
              </div>
            </div>
          );
        })}

        <AcceptRegulations />

        <button type="submit" className="form-control btn btn-primary btn-lg">
          Kupuję <span className="icon-shopping-bag"></span>
        </button>
      </div>
    </div>
  );
};

export default CartSummary;
